import React from 'react'
import { DropOptions } from '../../../../shared/components/forms/drop-options/DropOptions'
import {
  PostProjectUpdateStatusApiArg,
  usePostProjectUpdateStatusMutation,
} from '../../../../app/api'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import { setTariffUpdated } from '../../../../app/store/reducers/AuthSlice'
import { Tooltip } from 'antd'

type ProjectStatus = NonNullable<PostProjectUpdateStatusApiArg['body']['status']>

interface StatusCellProps {
  id: number
  status: string
  is_demo: boolean
}

export const StatusCell = ({ id, status, is_demo }: StatusCellProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [updateStatus] = usePostProjectUpdateStatusMutation()

  const options: { text: string; value: ProjectStatus; hidden: boolean }[] = [
    {
      text: t('pages.projects.activate'),
      value: 'active',
      hidden: ['Active'].includes(status),
    },
    {
      text: t('pages.projects.pause'),
      value: 'pause',
      hidden: ['On Pause', 'Archived'].includes(status),
    },
    {
      text: t('pages.projects.archive'),
      value: 'archive',
      hidden: status === 'Archived',
    },
  ]

  if (is_demo) {
    return (
      <span
        className={
          'whitespace-nowrap rounded-[6px] bg-success-300 py-[2px] px-[8px] text-[10px] font-semibold uppercase text-success-400'
        }
      >
        {t('pages.projects.statuses.Demo project')}
      </span>
    )
  }

  return (
    <DropOptions
      options={options}
      onChange={(value) => {
        updateStatus({ body: { id, status: value as ProjectStatus } }).then(() =>
          dispatch(setTariffUpdated()),
        )
      }}
    >
      <Tooltip title={t(`pages.projects.statusesTooltip.${status}`)}>
        <span
          className={`cursor-pointer whitespace-nowrap rounded-[6px] py-[2px] px-[8px] text-[10px] font-semibold uppercase ${
            {
              Active: 'bg-success-300 text-success-400',
              'On Pause': 'bg-danger/[.07] text-[#DA5533]',
              Archived: 'bg-aqua-300/[.07] text-aqua-300',
            }[status]
          }`}
        >
          {t(`pages.projects.statuses.${status}`)}
        </span>
      </Tooltip>
    </DropOptions>
  )
}
